'use strict';
var parent = require('../../stable/promise');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.promise.try');
require('../../modules/esnext.promise.with-resolvers');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/promise/index.js
// module id = 550
// module chunks = 13